import * as Actions from '../ActionTypes'
import {fetchWithTimeout} from '../../core/http'
import requests from '../../core/request'

const login = {
    request: {type: Actions.LOGIN_REQUEST},
    success (user) {
        return {
            type: Actions.LOGIN_SUCCESS,
            payload: user
        }
    },
    error: details => type => ({type, payload: details})
}

const logout = {type: Actions.LOGOUT_SUCCESS}

export const loginUser = function (email, password, onSuccess) {
    const {request, success, error: loginError} = login
    const {LOGIN_ERROR_UNAUTHORIZED, LOGIN_ERROR_NETWORK, LOGIN_ERROR_UNHANDLED, LOGIN_ERROR_SERVER, LOGIN_ERROR_INVALID_REQUEST} = Actions

    return dispatch => {
        dispatch(request)

        fetchWithTimeout(requests.auth.login, {email, password})
            .then(json => {
                onSuccess()
                dispatch(success(json.data))
            })
            .catch(err => {
                const error = loginError(err)

                if (!err || !err.response) dispatch(error(LOGIN_ERROR_NETWORK))
                else {
                    switch (err.response.status) {
                    case 403: dispatch(error(LOGIN_ERROR_UNAUTHORIZED))
                        break
                    case 422: dispatch(error(LOGIN_ERROR_INVALID_REQUEST))
                        break
                    case 500: dispatch(error(LOGIN_ERROR_SERVER))
                        break
                    default: dispatch(error(LOGIN_ERROR_UNHANDLED))
                    }
                }
            })
    }
}

export const logoutUser = function () {
    return dispatch => {
        localStorage.removeItem('token')
        dispatch(logout)
    }
}
